import { render, staticRenderFns } from "./ArticleImportLink.vue?vue&type=template&id=aca3072c&scoped=true"
import script from "./ArticleImportLink.vue?vue&type=script&lang=js"
export * from "./ArticleImportLink.vue?vue&type=script&lang=js"
import style0 from "./ArticleImportLink.vue?vue&type=style&index=0&id=aca3072c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca3072c",
  null
  
)

export default component.exports